import { render, staticRenderFns } from "./LoaderOverlay.vue?vue&type=template&id=26460142"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js"
import style0 from "./LoaderOverlay.vue?vue&type=style&index=0&id=26460142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports